import Navbar from "./Navbar";
import Footer from "./Footer";
import StepsSection from "./StepsSection";

const HowItWorks = () => {
  return (
    <div className="min-w-screen bg-white">
      <Navbar />
      <div style={{ paddingTop: 72 }}>
        <StepsSection />
      </div>
      <Footer />
    </div>
  );
};

export default HowItWorks;
